export default __webpack_public_path__ + "static/why_4-dbf60f160acb0c6f22c6260bd3a8c6b5.gif";